export default {
  employeeKiosk: '/ek',
};
